import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { AppCommonsModule } from '../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW1403Component } from './kymw1403.component';
import { GetPublishGoodsDataService } from './api-services/get-publish-goods-data.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


/**
 * 掲載商品検索画面 モジュール設定クラス
 *
 * @export KYMW1403Module
 * @class KYMW1403Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjInputModule,
    FontAwesomeModule
  ],
  declarations: [
    KYMW1403Component,
  ],
  providers: [
    GetPublishGoodsDataService,
  ],
})
export class KYMW1403Module {
}
